import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Chip, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HandshakeIcon from "@mui/icons-material/Handshake";
import Loader from "../../../../components/Loader/Loader";
import {
  FUNDING_STAGE_COLORS,
  formatFundingStageLabel,
  normalizeFundingStageKey,
} from "../../../../utils/dealFlowColumns";
import { getErrorMessage } from "../../../../utils/errorUtils";
import "../../../../components/common/css/datatable.scss";

const ComingSoonCamp = () => {
  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
  });

  const fetchuserCampaignData = useCallback(() => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-campaign-details-list",
      headers: {
        "x-access-token": token,
      },
      data: {
        status: 1,
        campaign_status: 9,
        sortBy: "",
        page: pageState.page,
        limit: pageState.pageSize,
        // searchTerm: searchTerm,
        isForAdminReview: 0,
      },
    };

    axios(config)
      .then(function (response) {
        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        const errorMessage = getErrorMessage(
          error,
          "Failed to load coming soon campaigns"
        );
        if (errorMessage) {
          Swal.fire({
            title: "Error",
            timer: 2500,
            timerProgressBar: true,
            text: errorMessage,
            icon: "error",
            confirmButtonColor: "#f27474",
            confirmButtonText: "OK",
            dangerMode: true,
            showCloseButton: true,
          });
        }
      });
  }, [pageState.page, pageState.pageSize]);

  useEffect(() => {
    fetchuserCampaignData();
  }, [fetchuserCampaignData]);

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/coming-soon-campaign/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>

          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "corporation_legal_name",
      headerName: "Campaign Name",
      width: 170,
    },
    // Deal Flow: Interest Stats Column (Favorites + Soft Commitments)
    {
      field: "interest",
      headerName: "Interest",
      width: 100,
      renderCell: (params) => {
        const favorites = params.row.favorite_count || 0;
        const commitments = params.row.soft_commitment_count || 0;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Tooltip title={`${favorites} favorites`} arrow>
              <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                <FavoriteIcon sx={{ fontSize: 16, color: "#e91e63" }} />
                <span style={{ fontSize: "12px" }}>{favorites}</span>
              </div>
            </Tooltip>
            <Tooltip title={`${commitments} soft commitments`} arrow>
              <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                <HandshakeIcon sx={{ fontSize: 16, color: "#1976d2" }} />
                <span style={{ fontSize: "12px" }}>{commitments}</span>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    // Deal Flow: Funding Stage Column
    {
      field: "funding_stage",
      headerName: "Stage",
      width: 120,
      renderCell: (params) => {
        const stageKey = normalizeFundingStageKey(params.row.funding_stage);
        if (!stageKey) {
          return <span style={{ color: "#999" }}>—</span>;
        }
        const colors = FUNDING_STAGE_COLORS[stageKey] || {
          bg: "#f5f5f5",
          color: "#666",
        };
        return (
          <Chip
            label={formatFundingStageLabel(stageKey)}
            size="small"
            sx={{
              backgroundColor: colors.bg,
              color: colors.color,
              fontWeight: 500,
              fontSize: "11px",
            }}
          />
        );
      },
    },
    {
      field: "city",
      headerName: "Location",
      width: 140,
    },
    {
      field: "entitytype",
      headerName: "Entity Type",
      width: 140,
    },
    {
      field: "camp_email",
      headerName: "Email",
      width: 180,
    },
  ];
  return (
    <div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          {/* <input type="text" placeholder="Search..." onChange={handleQuery} />
          <SearchOutlinedIcon className="sarchicon" /> */}
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Upcoming Campaigns </h5>
        <div></div>
      </div>
      <DataGrid
        className="datagrid"
        autoHeight
        rows={pageState.data}
        rowCount={pageState.total}
        rowsPerPageOptions={[10, 30, 50, 70, 100]}
        pagination
        page={pageState.page - 1}
        pageSize={pageState.pageSize}
        paginationMode="server"
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...old, page: newPage + 1 }));
        }}
        onPageSizeChange={(newPageSize) =>
          setPageState((old) => ({ ...old, pageSize: newPageSize }))
        }
        columns={userColumns.concat(actionColumn)}
      />
    </div>
  );
};

export default ComingSoonCamp;
